import { clsx } from "clsx";
import { useMemo } from "react";

import { IValidationResource, ValidationStatus } from "@sol/sdk";

import SkillLevelsMetrics from "./SkillLevelsMetrics";

type Props = {
    skillsCount: number;
    validations: IValidationResource[];
    className?: string;
};

const SkillsMetrics = ({ skillsCount, validations, className }: Props) => {
    // We have as many skillLevels as skills
    const skillLevelsCount = skillsCount;

    const [validLevels1, validLevels2, validLevels3] = useMemo(() => {
        const validLevels = [0, 0, 0];

        validations.forEach(validation => {
            if (validation.status === ValidationStatus.VALIDATED) {
                validLevels[validation.skillLevel.level - 1] += 1;
            }
        });

        return validLevels;
    }, [validations]);

    return (
        <ul
            className={clsx(
                "m-0 grid w-full grid-flow-row auto-rows-max grid-cols-12 gap-5 p-0 [&>li]:list-none",
                className,
            )}
        >
            <li className="col-span-12 min-w-0 xl:col-span-4">
                <SkillLevelsMetrics validLevels={validLevels1} levelsCount={skillLevelsCount} level={1} />
            </li>
            <li className="col-span-12 min-w-0 xl:col-span-4">
                <SkillLevelsMetrics validLevels={validLevels2} levelsCount={skillLevelsCount} level={2} />
            </li>
            <li className="col-span-12 min-w-0 xl:col-span-4">
                <SkillLevelsMetrics validLevels={validLevels3} levelsCount={skillLevelsCount} level={3} />
            </li>
        </ul>
    );
};

export default SkillsMetrics;
